// Б.2.c: Подпольный боец — passive «Не может атаковать, пока на нём нет
// Модификации».
//
// Реализация — через флаг card.cantAttack:
//   - На старте Card.cantAttack уже true (конструктор detect'ит "Не может
//     атаковать" в passive-тексте через includes).
//   - Когда первый Мод повешен → cantAttack=false.
//   - Когда последний Мод снят → cantAttack=true.
//
// Эффект cantAttack:
//   - Юнит не попадает в очередь Ф3 (collectPhase3Attackers фильтрует cantAttack).
//   - Контратака суппрессится в combat.unitVsUnit (defender.cantAttack →
//     defDmg=0). Это покрывает и ИИ-ядро (atk=0 — было 0 урона, теперь
//     явно через cantAttack), и Подпольного бойца.

export const CARD_ID = 'syn_podpolny_boets';

export function podpolnyyOnModAttached(card) {
  if (card?.id !== CARD_ID) return;
  // Любой Мод повешен → может атаковать.
  if ((card.modifications?.length ?? 0) >= 1) {
    card.cantAttack = false;
  }
}

export function podpolnyyOnModDetached(card) {
  if (card?.id !== CARD_ID) return;
  // Все Моды сняты → снова не может атаковать.
  if ((card.modifications?.length ?? 0) === 0) {
    card.cantAttack = true;
  }
}
